(function () {
  'use strict';

  var RING_R = 34; // must match the <circle r> in the section markup
  var RING_C = 2 * Math.PI * RING_R;

  function fmt(sec) {
    sec = Math.max(0, Math.round(sec));
    var m = Math.floor(sec / 60);
    var s = sec % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  function initRegimen(root) {
    if (root.dataset.rgInit) return;
    root.dataset.rgInit = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('.rg-item'));
    var line = root.querySelector('.rg-line');
    var fill = root.querySelector('.rg-line-fill');
    var timer = root.querySelector('.rg-timer');
    var timeEl = timer && timer.querySelector('.rg-timer-time');
    var labelEl = timer && timer.querySelector('.rg-timer-label');
    var ring = timer && timer.querySelector('.rg-timer-prog');
    if (!items.length || !line) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ---- Cursor-driven "push" tilt on each card -----------------------
   
    if (!reduce && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var MAX_TILT = 9; // degrees
      items.forEach(function (it) {
        var card = it.querySelector('.rg-card');
        if (!card) return;
        var rect = null;
        var raf = null;
        var nx = 0, ny = 0; 

        function apply() {
          raf = null;
          // Hovered edge rotates away (pushes in); opposite edge lifts.
          card.style.transform =
            'perspective(900px) translateZ(6px) rotateX(' + (ny * MAX_TILT) +
            'deg) rotateY(' + (-nx * MAX_TILT) + 'deg)';
          card.style.setProperty('--rg-gx', ((nx + 0.5) * 100).toFixed(1) + '%');
          card.style.setProperty('--rg-gy', ((ny + 0.5) * 100).toFixed(1) + '%');
        }

        card.addEventListener('pointerenter', function () {
          rect = card.getBoundingClientRect();
          card.classList.add('is-tilting');
        });
        card.addEventListener('pointermove', function (e) {
          if (!rect) rect = card.getBoundingClientRect();
          nx = (e.clientX - rect.left) / rect.width - 0.5;
          ny = (e.clientY - rect.top) / rect.height - 0.5;
          if (!raf) raf = requestAnimationFrame(apply);
        });
        card.addEventListener('pointerleave', function () {
          if (raf) { cancelAnimationFrame(raf); raf = null; }
          rect = null;
          card.classList.remove('is-tilting');
          card.style.transform = '';
        });
      });
    }

    // Per-step durations (seconds) + labels.
    var durations = items.map(function (it) {
      var d = parseFloat(it.getAttribute('data-duration'));
      return (isFinite(d) && d > 0) ? d : 30;
    });
    var labels = items.map(function (it) {
      var t = it.querySelector('.rg-step-title');
      return (t ? t.textContent : '').trim();
    });
    var total = durations.reduce(function (a, b) { return a + b; }, 0) || 1;

    // Cumulative time at each checkpoint. T[i] = time as the puck reaches
    // node i (start of step i); T[n] = total (puck at the bottom of the line).
    var T = [0];
    for (var i = 0; i < durations.length; i++) T.push(T[i] + durations[i]);

    if (ring) {
      ring.style.strokeDasharray = RING_C;
      ring.style.strokeDashoffset = RING_C;
    }

    // Geometry: vertical position of each step's marker centre, measured
    // from the top of the line. Recomputed on refresh/resize.
    var checkpoints = [];
    var lineH = 1;
    function measure() {
      var lr = line.getBoundingClientRect();
      lineH = lr.height || 1;
      var lineTopDoc = lr.top + window.scrollY;
      checkpoints = items.map(function (it) {
        var marker = it.querySelector('.rg-dot') || it;
        var nr = marker.getBoundingClientRect();
        var cy = (nr.top + window.scrollY) + nr.height / 2 - lineTopDoc;
        return Math.max(0, Math.min(lineH, cy));
      });
      checkpoints.push(lineH); // trailing checkpoint at the line's bottom
    }

    // Interpolate the routine time for a puck position y (0..lineH).
    function timeAt(y) {
      if (y <= checkpoints[0]) return 0;
      for (var k = 0; k < checkpoints.length - 1; k++) {
        if (y <= checkpoints[k + 1]) {
          var span = (checkpoints[k + 1] - checkpoints[k]) || 1;
          var f = (y - checkpoints[k]) / span;
          return T[k] + f * (T[k + 1] - T[k]);
        }
      }
      return total;
    }

    // Which step the puck is currently "in" (the segment below marker k).
    function activeIndex(y) {
      for (var k = 0; k < items.length; k++) {
        if (y < checkpoints[k + 1]) return k;
      }
      return items.length - 1;
    }

    var lastLabel = '';
    var lastActive = -1;
    var lastComplete = null;
    var lastTime = '';
    var firedComplete = false; // one-shot guard for the "routine complete" event
    function render(progress) {
      if (window.scrollY < 2) progress = 0;
      progress = Math.max(0, Math.min(1, progress));
      var y = progress * lineH;
      var t = timeAt(y);
      var lastCp = checkpoints.length ? checkpoints[items.length - 1] : lineH;
      var atPageBottom =
        (window.innerHeight + window.scrollY) >=
        (document.documentElement.scrollHeight - 2);
      var complete = t >= total - 0.5 || (atPageBottom && y >= lastCp);
      if (fill) fill.style.transform = 'scaleY(' + progress + ')';

      if (timeEl) {
        var txt = fmt(complete ? total : t);
        if (txt !== lastTime) { timeEl.textContent = txt; lastTime = txt; }
      }
      if (ring) ring.style.strokeDashoffset = RING_C * (1 - (complete ? 1 : Math.min(1, t / total)));
      var ai = activeIndex(y);
      if (ai !== lastActive || complete !== lastComplete) {
        for (var idx = 0; idx < items.length; idx++) {
          items[idx].classList.toggle('is-active', idx === ai && !complete);
          items[idx].classList.toggle('is-done', complete || idx < ai);
        }
        if (timer) timer.classList.toggle('is-complete', complete);
        lastActive = ai;
        lastComplete = complete;
      }

      // Fire once, the first time the puck reaches the very end. Anything
      // (like the completion popup) can listen for this on the section root.
      if (complete && !firedComplete) {
        firedComplete = true;
        root.dispatchEvent(new CustomEvent('regimen:complete', { bubbles: true }));
      }

      var wantLabel = complete ? 'Complete' : (labels[ai] || 'Start');
      if (labelEl && wantLabel !== lastLabel) {
        labelEl.textContent = wantLabel;
        lastLabel = wantLabel;
      }
    }
    function progressNow() {
      var lr = line.getBoundingClientRect();
      return (window.innerHeight / 2 - lr.top) / (lr.height || 1);
    }

    measure();

    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (it) { it.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-visible');
          io.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -12% 0px' });
      items.forEach(function (it) { io.observe(it); });
    }

    if (reduce) {
      render(0);
      return;
    }
    var queued = false;
    function onScroll() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        render(progressNow());
      });
    }
    function onResize() { measure(); onScroll(); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('load', onResize);
    render(progressNow());
  }

  function initAll() {
    var roots = document.querySelectorAll('.regimen');
    for (var i = 0; i < roots.length; i++) initRegimen(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.regimen');
      if (root) initRegimen(root);
    });
  }
})();
